import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';
import Error503 from '../Components/Pages/ErrorPages/ErrorPage503';
import PrivateRoute from './PrivateRoute';
import Loader from '../Layout/Loader';
import { useAuth } from '../_helper/Auth/AuthProvider';
import { needsEducationalLevel } from './redirectUtils';

const LayoutRoutes = () => {
  const { userData } = useAuth();
  
  // Check if user is of role 'user' and needs to set educational level
  // Note: Subscription checks are handled in PrivateRoute.jsx
  const shouldRedirectToEducationalLevel = () => {
    return userData && 
           userData.role === 'user' && 
           needsEducationalLevel(userData);
  };
  
  return (
    <Routes>
      {routes.map(({ path, Component, roles }, i) => {
        // Skip rendering app routes for users without educational level
        if (path.startsWith('/app/') && shouldRedirectToEducationalLevel()) {
          return (
            <Route 
              key={i}
              path={path}
              element={<Navigate to="/auth/register/educational-level" />}
            />
          );
        }
        
        return (
          <Route key={i} element={<PrivateRoute roles={roles} />}>
            <Route element={<AppLayout />}>
              <Route
                path={path}
                element={
                  <Suspense fallback={<Loader />}>
                    <Component />
                  </Suspense>
                }
              />
            </Route>
          </Route>
        );
      })}
      <Route path="*" element={<Error503 />} />
    </Routes>
  );
};

export default LayoutRoutes;